import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title = 'Insights Research - Automated Research Lifecycle System',
  description = 'Transform manual research processes into fully automated, auditable pipelines using coordinated AI agents. From Terms of Reference to policy recommendations.',
  keywords = 'research automation, AI agents, KoboToolbox, survey automation, data collection, statistical analysis, policy recommendations',
  image = '/og-image.jpg',
  url = 'https://insights-research.com',
  type = 'website'
}) => {
  const fullTitle = title.includes('Insights Research') ? title : `${title} | Insights Research`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Sprono LLC" />
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Insights Research" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional SEO Tags */}
      <link rel="canonical" href={url} />
      <meta name="theme-color" content="#007ad9" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": "Insights Research",
          "description": description,
          "url": url,
          "applicationCategory": "BusinessApplication",
          "operatingSystem": "Web",
          "offers": {
            "@type": "Offer",
            "price": "299",
            "priceCurrency": "USD",
            "priceValidUntil": "2024-12-31"
          },
          "provider": {
            "@type": "Organization",
            "name": "Sprono LLC",
            "url": "https://sprono.com"
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEOHead;